module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27069",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7011",
      "conversations-error-reporting": "static-1.8281",
      "conversations-internal-pub-sub": "static-1.15366",
      "conversations-internal-schema": "static-1.12010",
      "conversations-message-history": "static-1.10663",
      "conversations-test-sdk": "static-1.9822",
      "conversations-visitor-experience-components": "static-1.20432",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4889",
      "hs-test-utils": "static-1.7352",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10876",
      "I18n": "static-7.1454",
      "jasmine-immutable": "static-1.2327",
      "jasmine-runner": "static-1.5779",
      "quartz": "static-1.6175",
      "react-dlb": "static-1.62",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3901",
      "viral-links-lib": "static-1.6271",
      "visitor-ui-component-library": "static-1.5521",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3929",
      "atom": "static-1.4508",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4155",
      "conversations-infrastructure": "static-1.8305",
      "conversations-prop-types": "static-1.6788",
      "conversations-visibility-tools": "static-1.5134",
      "conversations-visitor-message-history": "static-1.19169",
      "cssUtils": "static-1.603",
      "enviro": "static-4.328",
      "flux-actions": "static-1.287",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15968",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4743",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3740",
      "sanitize-text": "static-1.7515",
      "signup-constants": "static-1.17614",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.476",
      "usage-tracker": "static-1.6788",
      "usage-tracker-core": "static-1.6638",
      "usage-tracker-multi": "static-1.5202",
      "usage-tracker-public": "static-1.6599",
      "visitor-ui-component-library-icons": "static-1.5332",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2889",
      "moment": "static-3.26",
      "quartz-core": "static-1.5394",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4218",
      "foundations-components": "static-1.6874",
      "foundations-theming": "static-1.3704",
      "UIComponents": "static-3.7823",
      "cv-backend-services": "static-1.1345",
      "immutable-less": "static-1.3921",
      "conversations-skeleton-state": "static-1.6725",
      "crm-events-viz-core": "static-1.31262",
      "icons": "static-2.596",
      "react-input-autosize": "static-2.17",
      "tanstack-virtual": "static-1.15",
      "rpc-client-utils": "static-1.4057",
      "ui-images": "static-2.968",
      "permission-components": "static-1.4700",
      "react-virtualized": "static-2.82",
      "HeadJS": "static-2.624",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2463",
      "msw": "static-1.39",
      "testing-library": "static-1.135",
      "i18n-data": "static-1.208",
      "moment-timezone": "static-5.68",
      "jasmine": "static-4.3670",
      "quartz-core-utils": "static-1.3042",
      "signup-ui-url-generator": "static-2.7439",
      "HubStyle": "static-2.11184",
      "sassPrefix": "static-1.142",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5205",
      "bender-build-tools": "static-1.2538",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.701",
      "hub-http-shared-msw-handlers": "static-1.8467",
      "hubspotter-http": "static-1.4004",
      "hubspotter-http-shared-msw-handlers": "static-1.8465",
      "mobile-manifest-mixins": "static-1.396",
      "platform-navigation-bootstrap": "static-1.11874",
      "quick-fetch": "static-1-hqd-latest.1",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.334",
      "hs-story-utils": "static-1.8727",
      "bend-plugin-foundations-components": "static-1.3143",
      "floating-ui": "static-1.41",
      "foundations-theming-specialty": "static-1.1420",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2187",
      "foundations-theming-base": "static-1.2689",
      "ts-schema": "static-1.3532",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1841",
      "content-assistance-lib": "static-1.6995",
      "crm-component-utils": "static-1.37448",
      "crm-display-components": "static-1.23198",
      "crm-fe-perf": "static-1.22323",
      "crm-links": "static-1.5555",
      "crm-message-bus": "static-1.41272",
      "crm-search-service-types": "static-1.632",
      "crm-source-interpretation-lib": "static-1.4651",
      "customer-data-communicator": "static-1.43818",
      "customer-data-email": "static-1.16952",
      "customer-data-filters-ui": "static-1.37497",
      "customer-data-objects": "static-1.7006",
      "customer-data-objects-ui-components": "static-1.12340",
      "customer-data-properties": "static-1.49556",
      "customer-data-rte": "static-1.31565",
      "customer-data-ui-utilities": "static-1.9133",
      "data-fetching-client": "static-1.9031",
      "draft-plugins": "static-2.20582",
      "file-manager-components": "static-1.21817",
      "FileManagerCore": "static-1.37316",
      "frontend-preferences-client": "static-1.7299",
      "hubspot-apollo-client": "static-1.4188",
      "hubspot-prosemirror": "static-1.16530",
      "object-comments-thread-lib": "static-1.9077",
      "reference-resolvers-lite": "static-1.7415",
      "ui-addon-upgrades": "static-9.16988",
      "universal-associations-select": "static-1.10295",
      "platform-infra-nav-components": "static-1.7114",
      "graphql": "static-1.67",
      "ai-components-ui-library": "static-1.7336",
      "superstore": "static-1.4079",
      "ui-addon-video-player": "static-1.8112",
      "ui-coaching-tips": "static-1.26766",
      "card-properties-lib": "static-1.42417",
      "crm-actions": "static-1.5568",
      "crm-cards-data": "static-1.377",
      "crm-cards-sdk": "static-1.41743",
      "customer-data-properties-shared-msw-handlers": "static-1.7794",
      "customer-data-property-utils": "static-1.7331",
      "customer-data-tracking": "static-1.6209",
      "framework-data-schema-resolvers": "static-1.6254",
      "usage-tracker-container": "static-1.6778",
      "framework-data-table": "static-2.10547",
      "location-customization-utils-lib": "static-1.7339",
      "calling-error-reporting": "static-1.30660",
      "calling-internal-common": "static-1.30654",
      "calling-usage-tracker": "static-1.5858",
      "crm_data": "static-4.90016",
      "crm_schema": "static-3.90055",
      "crm-legacy-global-containers": "static-1.23154",
      "customer-data-content": "static-1.26112",
      "draft-content-plugins": "static-1.26913",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.22903",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22601",
      "EmailSignatureEditor": "static-1.23138",
      "FileManagerLib": "static-1.37457",
      "hubspot-prosemirror-plugins": "static-1.16522",
      "integration-settings-components": "static-1.13504",
      "integrations-lib": "static-1.14247",
      "integrations-tracking-lib": "static-1.5010",
      "native-integrations-shared-strings": "static-1.7165",
      "nav-meta": "static-1.27857",
      "outreach-assistant-email-generation": "static-1.5035",
      "property-translator": "static-1.4730",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.35888",
      "react-colorpicker": "static-2.9619",
      "react-dnd-compat": "static-1.4031",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7534",
      "rich-text-lib": "static-1.18733",
      "sales-email-signature-service-client": "static-1.3286",
      "sequences-lib": "static-1.7124",
      "timezone-utils": "static-2.4559",
      "ui-addon-i18n": "static-1.10352",
      "ui-addon-iframeable": "static-1.8282",
      "ui-business-units-lib": "static-1.8288",
      "ui-gdpr-components": "static-1.9593",
      "ui-shepherd-react": "static-3.9430",
      "user-context": "static-1.4550",
      "whatsapp-sending-lib": "static-1.3770",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4088",
      "salesImages": "static-1.511",
      "customer-data-filters-ui-msw-helpers": "static-1.19931",
      "customer-data-reference-ui-components": "static-1.12433",
      "FormUrlGenerator": "static-2.4063",
      "framework-builder-read-service-client": "static-1.3480",
      "framework-data-schema-quick-fetch": "static-1.6159",
      "inbound-db-meta-service-client": "static-1.3139",
      "inbound-db-properties-service-client": "static-1.3360",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.376",
      "onboarding-tours": "static-1.15771",
      "SharedI18nStrings": "static-1.171",
      "ui-addon-teams": "static-1.20716",
      "calling-cross-tab-library": "static-1.18653",
      "calling-global-api": "static-1.62365",
      "calling-integration-cross-tab": "static-1.21434",
      "calling-lifecycle-internal": "static-1.63747",
      "calling-lifecycle-messages": "static-1.56041",
      "conditional-properties-service-client": "static-1.3320",
      "external-options-client-types": "static-1.3528",
      "google-libphonenumber": "static-1.21",
      "inbounddb-objects-service-types": "static-1.3631",
      "object-builder-ui-client": "static-1.46709",
      "pipeline-validation-client-types": "static-1.3325",
      "smart-property-lib": "static-1.4500",
      "tiered-pricing": "static-1.266",
      "ui-addon-form-validation": "static-1.10386",
      "directed-graph": "static-1.295",
      "event-emitter": "static-1.358",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3472",
      "video-components-external": "static-1.9457",
      "video-data-lib": "static-1.33115",
      "audio-components": "static-1.5138",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.34968",
      "video-components": "static-1.11460",
      "video-embed": "static-1.33949",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23603",
      "knowledge-content-types": "static-1.8036",
      "payment-link-components": "static-1.21943",
      "ui-addon-emoji-picker": "static-1.9293",
      "call-summary": "static-1.37056",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8613",
      "batch-promise": "static-1.956",
      "feature-store-service-types": "static-1.4009",
      "growth-monetization-service-types": "static-1.4016",
      "merchandise-lib": "static-1.236",
      "self-service-api": "static-1.9614",
      "upgrade-management-service-types": "static-1.4000",
      "chatspot-client-types": "static-1.10056",
      "chatspot-core": "static-1.18952",
      "ContentUtils": "static-1.66405",
      "copilot-toolkit": "static-1.9479",
      "growth-onboarding-feedback-components": "static-1.5860",
      "customer-data-sidebar": "static-2.44341",
      "enrichment-properties-lib": "static-1.13618",
      "persist-promise": "static-1.3114",
      "crm-pipelines-api-client-types": "static-1.3505",
      "customer-data-associations": "static-1.6592",
      "reporting-data": "static-1.64979",
      "ui-addon-draggable": "static-3.4217",
      "crm-record-cards-service-types": "static-1.3097",
      "crm_universal": "static-1.21174",
      "SalesContentIndexUI": "static-3.8176",
      "signup-ui-lego-core": "static-1.19624",
      "content-embed-lib": "static-1.6702",
      "data-model-builder-lib": "static-1.10287",
      "remote-ui": "static-1.52",
      "ui-components-test-utils": "static-1.5014",
      "ui-extensions-remote-renderer": "static-1.15464",
      "universal-page-editor-lib": "static-1.2411",
      "integrations-error-boundary-lib": "static-1.11662",
      "laboratory-lib": "static-3.6547",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9826",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8226",
      "messaging-types-lib": "static-1.44066",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15387",
      "sequences-client-types-lib": "static-1.6981",
      "foundations-components-test-utils": "static-1.4358",
      "magpie-lib": "static-1.5011",
      "navigation-messaging": "static-1.5547",
      "getting-started-shared-tasks": "static-1.16761",
      "getting-started-shared-tasks-store": "static-1.15879",
      "whatsapp-management-lib": "static-1.6929",
      "growth-data-modal": "static-1.4673",
      "growth-onboarding-confetti": "static-1.2436",
      "growth-onboarding-next-action-utils": "static-1.776",
      "navigation-components": "static-1.16220",
      "ui-shepherd-tracker": "static-1.6811",
      "shared-worker-versioning": "static-1.10433",
      "worker-connection-library": "static-1.15906",
      "calling-orchestration-shared-library": "static-1.33578",
      "onboarding-scopes": "static-1.5876",
      "breeze-intelligence-kit": "static-1.4708",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8550",
      "fsm": "static-1.3055",
      "policy-lib": "static-1.6121",
      "react-tinymce": "static-1.53517",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52643",
      "tinymce-plugins": "static-1.55757",
      "tinymce-themes": "static-1.54613",
      "commerce-products-lib": "static-1.7673",
      "content-media-composition-data-lib": "static-1.9702",
      "content-media-compositions": "static-2.13709",
      "idb-keyval": "static-1.29",
      "magpie-types": "static-1.4471",
      "media-bridge-lib": "static-1.17963",
      "content-icons-ui": "static-1.2018",
      "social-insights-client-types": "static-1.20328",
      "outpost": "static-1.3681",
      "commerce-analytics-service-client": "static-1.3018",
      "ui-addon-opt": "static-4.7858",
      "commerce-tours-lib": "static-1.5094",
      "growth-onboarding-reliability": "static-1.4485",
      "sales-checkout-service-client": "static-1.3030",
      "ai-addon-copilot-preview": "static-1.6548",
      "wootric-nps": "static-1.6178",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4114",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2353",
      "card-payment-highlight-lib": "static-1.35467",
      "card-subscription-highlight-lib": "static-1.37771",
      "commerce-billing-lib": "static-1.17434",
      "commerce-contract-lib": "static-1.9955",
      "crm_components": "static-3.90016",
      "invoices-highlight-card-lib": "static-1.52802",
      "orders-highlight-card-lib": "static-1.19999",
      "products-highlight-card-lib": "static-1.15958",
      "project-storage": "static-1.4050",
      "quotes-highlight-card-lib": "static-1.69803",
      "usage-based-billing-components-lib": "static-1.7049",
      "reporting-client-types": "static-1.2256",
      "react-flip-move": "static-1.55",
      "FireAlarmUi": "static-1.4028",
      "sales-templates-service-types-lib": "static-1.3590",
      "ui-asset-management-lib": "static-1.10081",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8563",
      "collaboration-sidebar": "static-1.56176",
      "data-model-commons-lib": "static-1.10897",
      "feedback-loader": "static-1.28044",
      "final-form": "static-1.53",
      "html-to-image": "static-1.38",
      "object-definition-builder-lib": "static-1.6342",
      "property-management-iframe": "static-1.10965",
      "reactflow": "static-1.45",
      "used-in-list-lib": "static-1.6197",
      "visual-association": "static-1.5155",
      "highcharts": "static-8.89",
      "reporting-visualizations": "static-1.57056",
      "ui-extensibility-client-types": "static-1.3401",
      "automation-platform-service-types": "static-1.2319",
      "ContentData": "static-1.66480",
      "email-portal-health-service-types": "static-1.383",
      "marketing-email-service-types": "static-1.1623",
      "reactive-lib": "static-1.102",
      "purchase-motions-components": "static-1.4814",
      "short-messages-app-service-client": "static-1.3398",
      "ui-tool-access": "static-1.9440",
      "calling-orchestration-schema": "static-1.33803",
      "trellis-story-utils": "static-1.3907",
      "storybook-react": "static-1.16",
      "hub-http-contrib": "static-1.2461",
      "interframe": "static-3.4123",
      "tinymce-data": "static-1.38728",
      "ui-addon-sales-email": "static-1.4564",
      "codemirror": "static-5.80",
      "layout-dnd-components": "static-1.11368",
      "layout-dnd-utils": "static-1.10343",
      "react-codemirror": "static-1.9969",
      "ui-brand-identity-lib": "static-1.12274",
      "NamespacedHubStyle": "static-2.8611",
      "products-iframe-lib": "static-1.6292",
      "products-ui-components-shared-msw-handlers": "static-1.8849",
      "hls.js": "static-1.24",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.3985",
      "ai-rendering-library": "static-1.8143",
      "ai-settings-ui-library": "static-1.6738",
      "chirp-fetch": "static-1.1352",
      "copilot-plugins": "static-1.9452",
      "commerce-shared-components-lib": "static-1.16901",
      "commerce-subscription-lib": "static-1.35348",
      "commerce-tools-ui-lib": "static-1.8935",
      "usage-tracker-session-replay": "static-1.4474",
      "utility-belt": "static-1.1856",
      "payments-enrollment-embed-lib": "static-1.20692",
      "quotes-ui-lib": "static-1.78519",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6022",
      "invoices-ui-lib": "static-1.52818",
      "commerce-products-api": "static-1.1308",
      "SafeStorage": "static-1.3739",
      "invoices-iframe-lib": "static-1.54876",
      "quotes-modal-lib": "static-1.100476",
      "reporting-ui-components": "static-2.62253",
      "subscription-experience-data-types": "static-1.13881",
      "association-translator": "static-1.2516",
      "crm-settings-header-lib": "static-1.7566",
      "settings-ui-nav": "static-2.9505",
      "chatspot-widget-iframe": "static-1.18944",
      "collaboration-sidebar-common": "static-1.972",
      "property-management-common": "static-1.3252",
      "d3": "static-1.7",
      "crm-object-map": "static-1.4329",
      "advanced-menus-core": "static-1.14206",
      "advanced-menus-lib": "static-1.11266",
      "ExportDialog": "static-6.9832",
      "ui-memberships-settings-lib": "static-1.32185",
      "nav-client-types": "static-1.1624",
      "purchase-motions-api": "static-1.4816",
      "trials-service-types": "static-1.3417",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8668",
      "browser-eslint": "static-2.57",
      "multi-currency-client-types": "static-1.3141",
      "sales-views-client-types": "static-1.3618",
      "highlight.js": "static-1.64",
      "reporting-action-components": "static-1.39630",
      "ui-addon-react-router-dom": "static-1.8961",
      "growth-onboarding-empty-states": "static-1.4879",
      "InboxConnectUtils": "static-4.13236",
      "payments-post-enroll-local-storage-lib": "static-1.4431",
      "qrcode-generator": "static-1.52",
      "amplitude-session-replay-browser": "static-1.45",
      "marketplace-ui-apps-core": "static-1.16389",
      "stripe-embedded-components": "static-1.6514",
      "products-ui-components": "static-1.38193",
      "totals-ui-components": "static-1.21950",
      "reporting-plugins": "static-1.9325",
      "reporting-reports": "static-1.64659",
      "reporting-snowflake": "static-1.53599",
      "crm-index-visualization-object-layout": "static-1.3987",
      "crm-object-search-query-utilities": "static-1.8283",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14205",
      "simple-menus-lib": "static-1.15722",
      "eligibility-engine-service-types": "static-1.2698",
      "dashboard-lib": "static-1.79174",
      "share-with-third-party-component-lib": "static-1.8066",
      "developer-experience-shared-components": "static-1.9712",
      "marketplace-ui-client-types": "static-1.15262",
      "marketplace-ui-common": "static-1.17855",
      "ui-addon-integrations-directory-panel": "static-2.7414",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3182",
      "commerce-totals-service-types": "static-1.3268",
      "campaign-roi-lib": "static-1.7105",
      "reporting-datasets-permissions-lib": "static-1.11762",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3341",
      "oauth-service-types": "static-1.3603",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27069",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7011",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8281",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15366",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12010",
      "conversations-message-history": "/conversations-message-history/static-1.10663",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9822",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20432",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4889",
      "hs-test-utils": "/hs-test-utils/static-1.7352",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10876",
      "I18n": "/I18n/static-7.1454",
      "jasmine-immutable": "/jasmine-immutable/static-1.2327",
      "jasmine-runner": "/jasmine-runner/static-1.5779",
      "quartz": "/quartz/static-1.6175",
      "react-dlb": "/react-dlb/static-1.62",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3901",
      "viral-links-lib": "/viral-links-lib/static-1.6271",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5521",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3929",
      "atom": "/atom/static-1.4508",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4155",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8305",
      "conversations-prop-types": "/conversations-prop-types/static-1.6788",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5134",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19169",
      "cssUtils": "/cssUtils/static-1.603",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.287",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15968",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4743",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3740",
      "sanitize-text": "/sanitize-text/static-1.7515",
      "signup-constants": "/signup-constants/static-1.17614",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "usage-tracker": "/usage-tracker/static-1.6788",
      "usage-tracker-core": "/usage-tracker-core/static-1.6638",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5202",
      "usage-tracker-public": "/usage-tracker-public/static-1.6599",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5332",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2889",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5394",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4218",
      "foundations-components": "/foundations-components/static-1.6874",
      "foundations-theming": "/foundations-theming/static-1.3704",
      "UIComponents": "/UIComponents/static-3.7823",
      "cv-backend-services": "/cv-backend-services/static-1.1345",
      "immutable-less": "/immutable-less/static-1.3921",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6725",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31262",
      "icons": "/icons/static-2.596",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.15",
      "rpc-client-utils": "/rpc-client-utils/static-1.4057",
      "ui-images": "/ui-images/static-2.968",
      "permission-components": "/permission-components/static-1.4700",
      "react-virtualized": "/react-virtualized/static-2.82",
      "HeadJS": "/HeadJS/static-2.624",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2463",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.135",
      "i18n-data": "/i18n-data/static-1.208",
      "moment-timezone": "/moment-timezone/static-5.68",
      "jasmine": "/jasmine/static-4.3670",
      "quartz-core-utils": "/quartz-core-utils/static-1.3042",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7439",
      "HubStyle": "/HubStyle/static-2.11184",
      "sassPrefix": "/sassPrefix/static-1.142",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5205",
      "bender-build-tools": "/bender-build-tools/static-1.2538",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.701",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8467",
      "hubspotter-http": "/hubspotter-http/static-1.4004",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8465",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.396",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11874",
      "quick-fetch": "/quick-fetch/static-1-hqd-latest.1",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.334",
      "hs-story-utils": "/hs-story-utils/static-1.8727",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3143",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1420",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2187",
      "foundations-theming-base": "/foundations-theming-base/static-1.2689",
      "ts-schema": "/ts-schema/static-1.3532",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1841",
      "content-assistance-lib": "/content-assistance-lib/static-1.6995",
      "crm-component-utils": "/crm-component-utils/static-1.37448",
      "crm-display-components": "/crm-display-components/static-1.23198",
      "crm-fe-perf": "/crm-fe-perf/static-1.22323",
      "crm-links": "/crm-links/static-1.5555",
      "crm-message-bus": "/crm-message-bus/static-1.41272",
      "crm-search-service-types": "/crm-search-service-types/static-1.632",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4651",
      "customer-data-communicator": "/customer-data-communicator/static-1.43818",
      "customer-data-email": "/customer-data-email/static-1.16952",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37497",
      "customer-data-objects": "/customer-data-objects/static-1.7006",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12340",
      "customer-data-properties": "/customer-data-properties/static-1.49556",
      "customer-data-rte": "/customer-data-rte/static-1.31565",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9133",
      "data-fetching-client": "/data-fetching-client/static-1.9031",
      "draft-plugins": "/draft-plugins/static-2.20582",
      "file-manager-components": "/file-manager-components/static-1.21817",
      "FileManagerCore": "/FileManagerCore/static-1.37316",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7299",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4188",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16530",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9077",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7415",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16988",
      "universal-associations-select": "/universal-associations-select/static-1.10295",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7114",
      "graphql": "/graphql/static-1.67",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7336",
      "superstore": "/superstore/static-1.4079",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8112",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26766",
      "card-properties-lib": "/card-properties-lib/static-1.42417",
      "crm-actions": "/crm-actions/static-1.5568",
      "crm-cards-data": "/crm-cards-data/static-1.377",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41743",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7794",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7331",
      "customer-data-tracking": "/customer-data-tracking/static-1.6209",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6254",
      "usage-tracker-container": "/usage-tracker-container/static-1.6778",
      "framework-data-table": "/framework-data-table/static-2.10547",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7339",
      "calling-error-reporting": "/calling-error-reporting/static-1.30660",
      "calling-internal-common": "/calling-internal-common/static-1.30654",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5858",
      "crm_data": "/crm_data/static-4.90016",
      "crm_schema": "/crm_schema/static-3.90055",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23154",
      "customer-data-content": "/customer-data-content/static-1.26112",
      "draft-content-plugins": "/draft-content-plugins/static-1.26913",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.22903",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22601",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23138",
      "FileManagerLib": "/FileManagerLib/static-1.37457",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16522",
      "integration-settings-components": "/integration-settings-components/static-1.13504",
      "integrations-lib": "/integrations-lib/static-1.14247",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5010",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7165",
      "nav-meta": "/nav-meta/static-1.27857",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5035",
      "property-translator": "/property-translator/static-1.4730",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.35888",
      "react-colorpicker": "/react-colorpicker/static-2.9619",
      "react-dnd-compat": "/react-dnd-compat/static-1.4031",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7534",
      "rich-text-lib": "/rich-text-lib/static-1.18733",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3286",
      "sequences-lib": "/sequences-lib/static-1.7124",
      "timezone-utils": "/timezone-utils/static-2.4559",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10352",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8282",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8288",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9593",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9430",
      "user-context": "/user-context/static-1.4550",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.3770",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4088",
      "salesImages": "/salesImages/static-1.511",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19931",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12433",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4063",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3480",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6159",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3139",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3360",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.376",
      "onboarding-tours": "/onboarding-tours/static-1.15771",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "ui-addon-teams": "/ui-addon-teams/static-1.20716",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18653",
      "calling-global-api": "/calling-global-api/static-1.62365",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21434",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63747",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56041",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3320",
      "external-options-client-types": "/external-options-client-types/static-1.3528",
      "google-libphonenumber": "/google-libphonenumber/static-1.21",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3631",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46709",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3325",
      "smart-property-lib": "/smart-property-lib/static-1.4500",
      "tiered-pricing": "/tiered-pricing/static-1.266",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10386",
      "directed-graph": "/directed-graph/static-1.295",
      "event-emitter": "/event-emitter/static-1.358",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3472",
      "video-components-external": "/video-components-external/static-1.9457",
      "video-data-lib": "/video-data-lib/static-1.33115",
      "audio-components": "/audio-components/static-1.5138",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.34968",
      "video-components": "/video-components/static-1.11460",
      "video-embed": "/video-embed/static-1.33949",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23603",
      "knowledge-content-types": "/knowledge-content-types/static-1.8036",
      "payment-link-components": "/payment-link-components/static-1.21943",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9293",
      "call-summary": "/call-summary/static-1.37056",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8613",
      "batch-promise": "/batch-promise/static-1.956",
      "feature-store-service-types": "/feature-store-service-types/static-1.4009",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4016",
      "merchandise-lib": "/merchandise-lib/static-1.236",
      "self-service-api": "/self-service-api/static-1.9614",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4000",
      "chatspot-client-types": "/chatspot-client-types/static-1.10056",
      "chatspot-core": "/chatspot-core/static-1.18952",
      "ContentUtils": "/ContentUtils/static-1.66405",
      "copilot-toolkit": "/copilot-toolkit/static-1.9479",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5860",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44341",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13618",
      "persist-promise": "/persist-promise/static-1.3114",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3505",
      "customer-data-associations": "/customer-data-associations/static-1.6592",
      "reporting-data": "/reporting-data/static-1.64979",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4217",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3097",
      "crm_universal": "/crm_universal/static-1.21174",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8176",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19624",
      "content-embed-lib": "/content-embed-lib/static-1.6702",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10287",
      "remote-ui": "/remote-ui/static-1.52",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5014",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15464",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2411",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11662",
      "laboratory-lib": "/laboratory-lib/static-3.6547",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9826",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8226",
      "messaging-types-lib": "/messaging-types-lib/static-1.44066",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15387",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6981",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4358",
      "magpie-lib": "/magpie-lib/static-1.5011",
      "navigation-messaging": "/navigation-messaging/static-1.5547",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16761",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15879",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.6929",
      "growth-data-modal": "/growth-data-modal/static-1.4673",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2436",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.776",
      "navigation-components": "/navigation-components/static-1.16220",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6811",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10433",
      "worker-connection-library": "/worker-connection-library/static-1.15906",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33578",
      "onboarding-scopes": "/onboarding-scopes/static-1.5876",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4708",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8550",
      "fsm": "/fsm/static-1.3055",
      "policy-lib": "/policy-lib/static-1.6121",
      "react-tinymce": "/react-tinymce/static-1.53517",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52643",
      "tinymce-plugins": "/tinymce-plugins/static-1.55757",
      "tinymce-themes": "/tinymce-themes/static-1.54613",
      "commerce-products-lib": "/commerce-products-lib/static-1.7673",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9702",
      "content-media-compositions": "/content-media-compositions/static-2.13709",
      "idb-keyval": "/idb-keyval/static-1.29",
      "magpie-types": "/magpie-types/static-1.4471",
      "media-bridge-lib": "/media-bridge-lib/static-1.17963",
      "content-icons-ui": "/content-icons-ui/static-1.2018",
      "social-insights-client-types": "/social-insights-client-types/static-1.20328",
      "outpost": "/outpost/static-1.3681",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3018",
      "ui-addon-opt": "/ui-addon-opt/static-4.7858",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5094",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4485",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3030",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6548",
      "wootric-nps": "/wootric-nps/static-1.6178",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4114",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2353",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35467",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37771",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17434",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.9955",
      "crm_components": "/crm_components/static-3.90016",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52802",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.19999",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.15958",
      "project-storage": "/project-storage/static-1.4050",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69803",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7049",
      "reporting-client-types": "/reporting-client-types/static-1.2256",
      "react-flip-move": "/react-flip-move/static-1.55",
      "FireAlarmUi": "/FireAlarmUi/static-1.4028",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3590",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10081",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8563",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56176",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.10897",
      "feedback-loader": "/feedback-loader/static-1.28044",
      "final-form": "/final-form/static-1.53",
      "html-to-image": "/html-to-image/static-1.38",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6342",
      "property-management-iframe": "/property-management-iframe/static-1.10965",
      "reactflow": "/reactflow/static-1.45",
      "used-in-list-lib": "/used-in-list-lib/static-1.6197",
      "visual-association": "/visual-association/static-1.5155",
      "highcharts": "/highcharts/static-8.89",
      "reporting-visualizations": "/reporting-visualizations/static-1.57056",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3401",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2319",
      "ContentData": "/ContentData/static-1.66480",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.383",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1623",
      "reactive-lib": "/reactive-lib/static-1.102",
      "purchase-motions-components": "/purchase-motions-components/static-1.4814",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3398",
      "ui-tool-access": "/ui-tool-access/static-1.9440",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33803",
      "trellis-story-utils": "/trellis-story-utils/static-1.3907",
      "storybook-react": "/storybook-react/static-1.16",
      "hub-http-contrib": "/hub-http-contrib/static-1.2461",
      "interframe": "/interframe/static-3.4123",
      "tinymce-data": "/tinymce-data/static-1.38728",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4564",
      "codemirror": "/codemirror/static-5.80",
      "layout-dnd-components": "/layout-dnd-components/static-1.11368",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10343",
      "react-codemirror": "/react-codemirror/static-1.9969",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12274",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8611",
      "products-iframe-lib": "/products-iframe-lib/static-1.6292",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8849",
      "hls.js": "/hls.js/static-1.24",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3985",
      "ai-rendering-library": "/ai-rendering-library/static-1.8143",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6738",
      "chirp-fetch": "/chirp-fetch/static-1.1352",
      "copilot-plugins": "/copilot-plugins/static-1.9452",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16901",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35348",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8935",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4474",
      "utility-belt": "/utility-belt/static-1.1856",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20692",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78519",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6022",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52818",
      "commerce-products-api": "/commerce-products-api/static-1.1308",
      "SafeStorage": "/SafeStorage/static-1.3739",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54876",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100476",
      "reporting-ui-components": "/reporting-ui-components/static-2.62253",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13881",
      "association-translator": "/association-translator/static-1.2516",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7566",
      "settings-ui-nav": "/settings-ui-nav/static-2.9505",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18944",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.972",
      "property-management-common": "/property-management-common/static-1.3252",
      "d3": "/d3/static-1.7",
      "crm-object-map": "/crm-object-map/static-1.4329",
      "advanced-menus-core": "/advanced-menus-core/static-1.14206",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11266",
      "ExportDialog": "/ExportDialog/static-6.9832",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32185",
      "nav-client-types": "/nav-client-types/static-1.1624",
      "purchase-motions-api": "/purchase-motions-api/static-1.4816",
      "trials-service-types": "/trials-service-types/static-1.3417",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8668",
      "browser-eslint": "/browser-eslint/static-2.57",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3141",
      "sales-views-client-types": "/sales-views-client-types/static-1.3618",
      "highlight.js": "/highlight.js/static-1.64",
      "reporting-action-components": "/reporting-action-components/static-1.39630",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8961",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4879",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13236",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4431",
      "qrcode-generator": "/qrcode-generator/static-1.52",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16389",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6514",
      "products-ui-components": "/products-ui-components/static-1.38193",
      "totals-ui-components": "/totals-ui-components/static-1.21950",
      "reporting-plugins": "/reporting-plugins/static-1.9325",
      "reporting-reports": "/reporting-reports/static-1.64659",
      "reporting-snowflake": "/reporting-snowflake/static-1.53599",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.3987",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8283",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14205",
      "simple-menus-lib": "/simple-menus-lib/static-1.15722",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2698",
      "dashboard-lib": "/dashboard-lib/static-1.79174",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8066",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9712",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15262",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17855",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7414",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3182",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3268",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7105",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11762",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3341",
      "oauth-service-types": "/oauth-service-types/static-1.3603",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};